import { SecondaryHeading } from "../../page/SecondaryHeading";
import { EntriesHeading } from "./EntriesHeading";
import { isDivisionTeamType } from "../../../eventDivisions/helpers";
import { ScanEntriesWidget } from "../../../routes/events/id/divisions/eventDivisionId/entries/ScanEntriesWidget";
import { useEntriesState } from "./useEntriesState";
import { useEventDivision } from "../../../routes/events/id/divisions/eventDivisionId/EventDivisionProvider";

export const GroupedEntriesHeading = ({ allEntries, manageEntries }) => {
    const { confirmed, registered, alternates } = useEntriesState(allEntries.map(ed => ed.entries).flat(1));
    const eventDivision = useEventDivision();
    const isTeams = isDivisionTeamType(eventDivision);
    const useNFC = manageEntries && eventDivision.getIn?.(["format_definition", "use_nfc"]);

    return (
        <SecondaryHeading
            heading={<EntriesHeading isTeams={isTeams} registered={registered.length} confirmed={confirmed}/>}
            actions={useNFC && <ScanEntriesWidget isTeams={isTeams} registered={registered} alternates={alternates}/>}
        />
    );
};
